export const PERMISSION_KEY = {
  TENANT_MANAGEMENT: 'tenantManagement',
  STAFF: 'staff',
  CURRENCIES: 'currencies',
  LANGUAGES: 'languages',
  CMS: 'cms',
  GAMES: 'games',
  GAME_PROVIDERS: 'gameProviders',
  GAME_STUDIOS: 'studios',
  COUNTRIES: 'countries',
  GAME_AGGREGATORS: 'gameAggregators',
  GAME_CATEGORIES: 'gameCategories',
  GAME_SUB_CATEGORIES: 'gameSubCategories',
  FINANCIAL_TRANSACTIONS: 'financialTransactions',
  CASINO_TRANSACTIONS: 'casinoTransactions',
  REGISTRATION: 'registration',
  BONUS: 'bonus',
  KYC_SETTINGS: 'kycSettings',
  BANNED_GAMES: 'bannedGames',
  WAGERING_TEMPLATE: 'wageringTemplate',
  EMAIL_TEMPLATE: 'emailTemplate',
  LOYALTY_MANAGEMENT: 'loyaltyManagement',
  IMAGE_GALLERY: 'imageGallery',
  BANNER_MANAGEMENT: 'bannerManagement',
  TRANSLATIONS: 'translations',
  CASHIER_METHODS: 'cashierMethods',
  REVIEW_MANAGEMENT: 'reviewManagement',
  GROUP_MANAGEMENT: 'groupManagement',
  TOURNAMENT: 'Tournament',
  FLAGGED_PLAYERS: 'flaggedPlayers',
  AML_FLAGGED_PLAYERS: 'amlFlaggedPlayers',
  SELF_EXCLUDED_PLAYERS: 'selfExcludedPlayers',
  BANNED_PLAYERS: 'bannedPlayers',
  BANNED_PLAYER_SETTING: 'bannedPlayerSetting',
  SET_THRESHOLDS: 'setThresholds',
  AML_SET_THRESHOLDS: 'amlSetThresholds',
  ERROR_MANAGEMENT: 'errorManagement',
  OTHER_SETTINGS: 'otherSettings',
  TENANTSETTING: 'settings',
  PLAYERS: 'players',
  HOME_PAGE: 'homePage',
  ACCOUNT_PAGE: 'accountPage'
}

// Mapping of routes to their corresponding module keys for permission checking.
export const routeToModuleKey = {
  'home-page': 'HomeUIManagement',
  'accounts-page': 'AccountUIManagement'
}

// Common excluded permissions
const commonExcludedPermissions = ['UIManagement', 'CasinoManagement', 'RG', 'AML', 'Tournament', 'Themes', 'TenantConfigurations']

// Permissions that should be excluded for Super Admin users
export const excludedPermissionKeysForSuperAdmin = ['TenantSettings', ...commonExcludedPermissions]

// Permissions that should be excluded for Tenant users
export const excludedPermissionKeysForTenant = ['Settings', ...commonExcludedPermissions]

// Permissions that should be excluded for Tenant creation
export const excludedPermissionKeysForTenantCreation = ['KycLabel', ...commonExcludedPermissions]
